// Contenuti del funnel Mirlos Company

export const QUIZ_TITLE =
  "triplica il tuo fatturato e svincolati dalle agenzie di marketing";
export const QUIZ_SUBTITLE =
  "rispondi a 3 domande e ricevi la strategia su misura per far crescere il tuo fatturato, senza più dipendere dalle agenzie";

export const QUESTIONS = [
  {
    id: "q_goal",
    label: "Domanda 02",
    text: "Qual è il tuo obiettivo aziendale per i prossimi 12 mesi?",
    options: [
      { key: "g1", label: "Raddoppiare il fatturato" },
      {
        key: "g2",
        label:
          "Inserire l'AI nei processi aziendali + creare un sito web/piattaforma interna",
      },
      {
        key: "g3",
        label:
          "Triplicare il fatturato, potenziare le abilità di vendita del team e liberarsi dal peso dell'azienda sulle spalle",
      },
    ],
  },
  {
    id: "q_budget",
    label: "Domanda 03",
    text: "Quanto sei pronto a investire per formare la tua attività?",
    helper: "In base alla tua scelta ti mostriamo la soluzione più adatta a te.",
    isBudget: true,
    options: [
      {
        key: "budget1",
        label: "A partire da 6.000€",
        sub: "per formare la mia azienda nel marketing e raddoppiare il fatturato - anche finanziabile fino a 36 mesi",
      },
      {
        key: "budget2",
        label: "Tra 14.990€ e 18.990€",
        badge: "Il nostro best seller",
        sub: "per triplicare il fatturato, potenziare le abilità di vendita e sentire meno il peso dell'azienda sulle spalle - anche finanziabile fino a 36 mesi",
      },
      {
        key: "budget3",
        label: "Da 25.490€ a 28.490€",
        sub: "tutto il best seller più call mensili di analisi e allineamento per 6 mesi, creazione sito web/piattaforma aziendale, aggiunta di AI in azienda - anche finanziabile fino a 36 mesi",
      },
    ],
  },
];

// Testimonial mostrati tra una domanda e l'altra
export const INTERSTITIALS = [
  {
    kicker: "Risultati reali",
    text: "6 aziende lo scorso anno hanno totalizzato ben 13 milioni di euro extra sui loro fatturati grazie al nostro metodo.",
    image:
      "https://images.pexels.com/photos/36733295/pexels-photo-36733295.jpeg",
  },
  {
    kicker: "Case study — Tircar",
    text: "Tircar di Benito Cinieri ha fatturato 3.3 milioni di euro in più grazie al nostro metodo in 8 mesi.",
    image:
      "https://images.unsplash.com/photo-1618642624018-a370cbf3cd80",
  },
  {
    kicker: "Case study — Immobiliare",
    text: "Tommaso Provenzano ha venduto 1.3 milioni di euro extra in immobili grazie alla nostra formazione.",
    image:
      "https://images.pexels.com/photos/7031607/pexels-photo-7031607.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    kicker: "Case study — Carweb",
    text: "Carweb ha quintuplicato le vendite in 5 mesi grazie alla nostra formazione.",
    image:
      "https://images.unsplash.com/photo-1644749700856-a82a92828a1b",
  },
];

// Casi studio mostrati alla fine (schermata di ringraziamento)
export const CASE_STUDIES = [
  {
    company: "Rassegna Stampa",
    featured: true,
    image: "/mirlos-rassegna-stampa.jpg",
    text: "Sei aziende italiane hanno messo insieme oltre 13 milioni di euro di fatturato extra in dodici mesi grazie al metodo di Mirlo's Company.",
  },
  {
    company: "Tommaso Provenzano",
    text: "Ha venduto 1,3 milioni di euro extra in immobili grazie alla nostra formazione dedicata alle tecniche di vendita.",
  },
  {
    company: "Carweb",
    text: "Ha quintuplicato le vendite in 5 mesi applicando le strategie apprese durante il percorso formativo.",
  },
  {
    company: "Casalnuovo",
    text: "Ha aumentato prenotazioni ed eventi al locale, riempiendo anche le serate prima vuote, tutto già nei primi 5 mesi.",
  },
];

// Feedback mostrati tra una domanda e l'altra (2 per slide)
export const FEEDBACK_CASES = [
  {
    company: "Tircar",
    text: "L'azienda di Benito Cinieri ha fatturato 3,3 milioni di euro in più grazie al nostro metodo in soli 8 mesi.",
  },
  {
    company: "Brace e Sapori",
    text: "Ha registrato 700 coperti in più al mese grazie al nostro intervento: un vero record.",
  },
  {
    company: "Pool Garden",
    text: "Ha generato 6.200 lead in target, decine e decine di contratti chiusi e il 2026 già pieno dalla fine del 2024.",
  },
  {
    company: "Daniele Pescara",
    text: "Ha acquisito clienti alto-spendenti, con fatturati dai 5 milioni in su.",
  },
];

// Coppie di feedback (2 per slide)
export const FEEDBACK_PAIRS = [
  FEEDBACK_CASES.slice(0, 2),
  FEEDBACK_CASES.slice(2, 4),
];


export const MANIFESTO = [
  {
    n: "01",
    title: "Il sapere resta dentro la tua azienda",
    body: "Non affittiamo risultati temporanei. Ti formiamo per rendere interno il know-how che oggi paghi alle agenzie.",
  },
  {
    n: "02",
    title: "Un metodo, non promesse",
    body: "Strategie testate su decine di imprese italiane, con casi documentati di crescita a doppia e tripla cifra.",
  },
  {
    n: "03",
    title: "Esperti reali al tuo fianco",
    body: "Marketing, vendite e negoziazione, immagine imprenditoriale: percorsi guidati da professionisti dedicati.",
  },
];

export const HERO_IMAGE =
  "https://images.pexels.com/photos/9701960/pexels-photo-9701960.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
